import { useRef, useEffect } from "react";

export const useDebouncedCallback = (
  effect: () => void,
  deps: React.DependencyList,
  debounceFor = 400,
) => {
  const ref = useRef<ReturnType<typeof setTimeout> | null>(null);
  const callbackRef = useRef(effect);

  useEffect(() => {
    callbackRef.current = effect;
  });

  useEffect(() => {
    ref.current = setTimeout(() => {
      callbackRef.current();
    }, debounceFor);

    return () => {
      if (ref.current) {
        clearTimeout(ref.current);
        ref.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceFor, ...deps]);
};
